/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018, 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

import React, { Component } from 'react';
import { SVGIcon } from '@ba/ba-ui-carbon-toolkit';
import noRelationshipDiagram from '@ba/ba-graphics/dist/illustrations-js/no-relationship-diagram_128';
import RelationshipDiagram from '@ba/ba-graphics/dist/illustrations-js/data-relationships-card_128';
import StringResources from 'nls/StringResources';

import PropTypes from 'util/PropTypes';

import Empty from 'components/empty/Empty';

class RelationshipVisErrorView extends Component {

	render() {
		const strings = this.props.error && this.props.error.getUserStrings && this.props.error.getUserStrings() || {};
		let alignment = this.props.alignment;
		if(!alignment){
			alignment = 'center';
		}
		let iconId = this.props.iconId;
		if(iconId === undefined){
			iconId = this._getErrorIcon().id;
		}
		let suggestions = this.props.suggestions || strings.suggestions;
		if(suggestions === undefined){
			suggestions = StringResources.get('startingPoints_unable_to_render_diagram_suggestions');
		}
		return (
			<Empty
				icon= {this.props.iconId !== null ? <SVGIcon iconId={iconId} size="xxlarge"/> : null}
				alignment = {alignment}
				title={this.props.preferredTitle || strings.title || this.props.defaultTitle}
				description={this.props.preferredDescription || strings.message || this.props.defaultDescription}
				selectable={true}
				suggestions = {suggestions}
			/>
		);
	}

	_getErrorIcon(){
		const error = this.props.error;
		if(error && error.id === 'RUN_REQUEST_IN_BACKGROUND'){
			return RelationshipDiagram;
		}
		return noRelationshipDiagram;
	}
}

RelationshipVisErrorView.propTypes = {
	error: PropTypes.object,
	defaultTitle: PropTypes.string,
	defaultDescription: PropTypes.string,
	alignment: PropTypes.string,
	iconId : PropTypes.string,
	preferredTitle: PropTypes.string,
	preferredDescription: PropTypes.string,
	suggestions : PropTypes.bool
};

export default RelationshipVisErrorView;



// WEBPACK FOOTER //
// ./src/js/components/startingPoints/relationshipGraph/RelationshipVisErrorView.js